import UserStatusToken from '@apps/truevail/admin/tokens/user_status'
import AccountToken from '@admin/tokens/account'
import Panel from '@admin/components/panel'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Users)',
  collection: {
    endpoint: `/api/admin/truevail/agency/advisors/${props.advisor.id}/users`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Name)', key: 'last_name', primary: true, format: AccountToken },
      { label: 't(Activated)', key: 'account.activation_at', primary: true, collapsing: true, format: UserStatusToken }
    ],
    defaultSort: { key: 'last_name', order: 'asc' },
    empty: {
      svg: 'user_round',
      title: 't(No Active Users)',
      text: 't(There are no active users for this advisor)',
      buttons: [
        { 
          label: 'Add User', 
          modal: <New advisor={ props.advisor } /> 
        }
      ]
    },
    recordTasks: (record) => [
      {
        label: 't(Send Activation Email)',
        svg: 'mail',
        show: record.account.activated_at === null,
        request: {
          method: 'PATCH',
          endpoint: `/api/admin/truevail/agency/advisors/${props.advisor.id}/users/${record.id}/activate`,
          onFailure: (result) => context.flash.set('error', 't(Unable to resend activation)'),
          onSuccess: (result) => context.flash.set('success', 't(The activation email was successfully resent)')
        }
      }
    ],
    entity: 'user'
  },
  tasks : {
    svg: 'plus',
    items: [
      { 
        label: 'Add User', 
        modal: <New advisor={ props.advisor } /> 
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
